import { render } from "./HeaderMobile.vue?vue&type=template&id=22059cb6&scoped=true"
import script from "./HeaderMobile.vue?vue&type=script&lang=js"
export * from "./HeaderMobile.vue?vue&type=script&lang=js"

import "./HeaderMobile.vue?vue&type=style&index=0&id=22059cb6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22059cb6"]])

export default __exports__